// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__OjzSP","Spacer":"Dashboard_Spacer__xe3dB","scoreCards":"Dashboard_scoreCards__5nZBn"};